const ConversationList = () =>
  import(/* webpackChunkName: "messaging" */ "./pages/ListPage.vue");
const ConversationDetail = () =>
  import(/* webpackChunkName: "messaging" */ "./pages/FormPage.vue");
const ConversationIndex = () =>
  import(/* webpackChunkName: "messaging" */ "./pages/IndexPage.vue");
const ConversationShow = () =>
  import(/* webpackChunkName: "messaging" */ "./pages/ConversationShow.vue");

export default [
  {
    path: "/conversation",
    component: ConversationIndex,
    redirect: "/conversation/list",
    name: "conversation",
    children: [
      {
        path: "list",
        component: ConversationList,
        name: "conversation.list",
      },
      {
        path: "create",
        component: ConversationDetail,
        name: "conversation.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: ConversationDetail,
        name: "conversation.edit",
        props: { create: false },
      },
      {
        path: "show/:id",
        component: ConversationShow,
        name: "conversation.show",
      },
      {
        path: "show/:id/:messageid",
        component: ConversationShow,
        name: "conversation.show_message",
      },
    ],
  },
];
